import React from 'react';
import PropTypes from 'prop-types';

import TreeSelector from 'components/TreeSelector';

import { Section } from '../../Section';

import { InputWrapper } from './styles';

export const CountriesSection = ({ data, value, animationIndex, onChange }) => {
	return (
		<Section title="Countries operated in" animationIndex={animationIndex}>
			<InputWrapper>Region</InputWrapper>
			<TreeSelector
				data={data}
				name={`updatedGeographies`}
				value={value}
				onChange={onChange}
			/>
		</Section>
	);
};

CountriesSection.propTypes = {
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};
